export type Pick = number | string | undefined;

export type Pickem = {
  driverPicks: string[] | undefined;
  picks: { [id: string]: Pick };
};

export const getNumberPick = (
  picks: {
    [id: string]: Pick;
  },
  id: string
) => {
  const value = picks[id];
  return typeof value === "number" ? value : undefined;
};

export const getStringPick = (
  picks: {
    [id: string]: Pick;
  },
  id: string
) => {
  const value = picks[id];
  return typeof value === "string" ? value : undefined;
};
